import React, { memo } from 'react';

import { Placement as Nav4ProjectsSection } from '@post-office/placements/nav-4-projects-section';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { PostOfficeProvider } from '@atlassian/jira-post-office-provider/src/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';

type Props = {
	onMessageCountChange?: (numberOfMessages: number) => void;
};

export const Nav4ProjectsSectionPlacement = memo(({ onMessageCountChange }: Props) => {
	// Atlaspack couldn't bundle Post Office placement, so we need to return null here
	// https://atlassian.slack.com/archives/C0288U06PGC/p1755502530582239
	if (__SERVER__) {
		return null;
	}

	return (
		<UFOSegment name="jira-growth-nav-4-projects-section">
			<JSErrorBoundary
				id="growthNav4ProjectsSection"
				packageName="@atlassian/jira-growth-nav-4-projects-section"
				teamName="Sequoia"
				fallback="unmount"
			>
				<PostOfficeProvider>
					<Nav4ProjectsSection onMessageCountChange={onMessageCountChange} />
				</PostOfficeProvider>
			</JSErrorBoundary>
		</UFOSegment>
	);
});
